const isProduction = () => process.env.REACT_APP_ENV === 'prod';

export default isProduction;
